import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  employerApplicationsKey,
  errorMessage,
  searchEnterpriseApplicationsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useEnterprisreSearchAppliationsProps = {
  searchValue: string;
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useEnterprisreSearchAppliations = ({
  searchValue,
  setAlertText = () => { },
}: useEnterprisreSearchAppliationsProps) => {
  const { data: searchApplicationsData, isFetching: isSearchingApplications } =
    useQuery({
      queryKey: [searchValue, employerApplicationsKey],
      queryFn: () =>
        axiosInstance
          .post(searchEnterpriseApplicationsRoute, { query: searchValue })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
      enabled: searchValue?.length > 2,
      refetchOnWindowFocus: false,
    });

  return {
    searchApplicationsData,
    isSearchingApplications,
  };
};
